import type { ComponentProps } from "react";
import { ProviderType } from "@wags/catalog/pure.ts";
import {
    clearCompatQuestions,
    clearPendingContact,
    requestOpenChat,
} from "@/features/kits-conversations";
import {
    openProviderClaim,
    PROVIDER_CLAIM_VISIBLE,
    ProviderClaimEntryCard,
} from "@/features/providers";

const ARI_TRUSTED_WAGS_ORIGIN = "https://www.wags.com";

export function ClaimEntry({
    providerId,
    providerName,
    providerType,
    listingId,
    photoUrl,
    locationLabel,
    surface,
    className,
    enabled,
    isVerified,
}: {
    providerId: string | null | undefined;
    providerName: string | null | undefined;
    providerType: ProviderType;
    listingId?: string;
    photoUrl?: string | null;
    locationLabel?: string;
    surface?: ComponentProps<typeof ProviderClaimEntryCard>["surface"];
    className?: string;
    enabled: boolean;
    isVerified: boolean;
}) {
    if (!PROVIDER_CLAIM_VISIBLE || !enabled || !providerId || isVerified)
        return null;
    const name = providerName?.trim() || undefined;
    const providerKind =
        providerType === ProviderType.Breeder ? "breeder" : "shelter";
    const startClaim = () => {
        clearPendingContact();
        clearCompatQuestions();
        openProviderClaim({
            listingId,
            provider: {
                id: providerId,
                kind: providerKind,
                url: `${ARI_TRUSTED_WAGS_ORIGIN}/provider/${providerId}`,
                name,
                photoUrl,
                locationLabel: locationLabel?.trim() || undefined,
            },
        });
        requestOpenChat();
    };
    return (
        <ProviderClaimEntryCard
            subject={listingId ? "listing" : "page"}
            providerName={name}
            providerKind={providerKind}
            surface={surface}
            className={className}
            onStart={startClaim}
        />
    );
}
